module.exports = __webpack_public_path__ + "static/media/east.9b810f93.jpg";